import React, { useEffect, useState } from "react";
import { Typography, Box } from "@mui/material";
import MuiTab from "../../../CommonComponents/Tab/MuiTab";
import classes from "./Investigation.module.css";
import InvestigatorsTab from "./InvestigatorsTab";
import PropTypes from "prop-types";
import CommonModal from "../../../CommonComponents/Modal/CommonModal";
import UploadDocument from "../../CaseManagement/Actions/UploadDoucument/UploadDocument";
import { getInvestigatorListWithCaseId } from "../../../Services/approval.service";
import { getInvestigatorListwithLabel } from "../../../Utils/helper";

const InvestigatorBlocks = ({
  caseId,
  investigators = [],
  setInvestigators = () => {},
  indexOfInvestigatorsDeatilsArray,
  InvestigatorBlocksClickHandler = () => {},
  InvestigationAssignedBlockClickHandler = () => {},
  onUploadButtonClickHandler = () => {},
  InvestigationAssignedBlockValueArray = [],
  openUploadDocuments,
  setOpenUploadDocuments,
  ApprovalInvestigationAssignedBlocks = [],
  ApprovalInvestigationListTabs = [],
  InvestigatorTabDetails = [],
  ApprovalInvestigationAssignedBlocksContents = [],
}) => {
  // const [investigators, setInvestigators] = useState([]);
  // useEffect(() => {
  //   //replace case id with dynamic value from props @laique when u will integrate approval case list api
  //   getInvestigatorListWithCaseId({ caseId: 1 })
  //     .then((data) => {
  //       setInvestigators(
  //         getInvestigatorListwithLabel(
  //           data?.data?.assignedToInvestigatorsWithIds
  //         )
  //       );
  //     })
  //     .catch((err) => {
  //
  //     });
  // }, []);

  return (
    <>
      <Box className={classes["investigator-blocks-main-container"]}>
        {/* <Typography className={classes["investigator-blocks-title"]}>
          Select Investigator to view details
        </Typography>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <MuiTab
            tabs={investigators}
            variant="grayShadow"
            onClick={InvestigatorBlocksClickHandler}
            fontSize="1.1rem"
            gap="3px"
            padding="8px 19px 8px 19px"
          />
        </Box> */}
        <InvestigatorsTab
          indexOfInvestigatorsDeatilsArray={indexOfInvestigatorsDeatilsArray}
          InvestigationAssignedBlockClickHandler={
            InvestigationAssignedBlockClickHandler
          }
          InvestigationAssignedBlockValueArray={
            InvestigationAssignedBlockValueArray
          }
          onUploadButtonClickHandler={onUploadButtonClickHandler}
          ApprovalInvestigationAssignedBlocks={
            ApprovalInvestigationAssignedBlocks
          }
          InvestigatorTabDetails={InvestigatorTabDetails}
          ApprovalInvestigationAssignedBlocksContents={
            ApprovalInvestigationAssignedBlocksContents
          }
        />
        <CommonModal
          open={openUploadDocuments}
          onClose={() => setOpenUploadDocuments(false)}
          width="30%"
        >
          {<UploadDocument />}
        </CommonModal>
      </Box>
    </>
  );
};

InvestigatorBlocks.propTypes = {
  caseId: PropTypes.number,
  investigators: PropTypes.array,
  setInvestigators: PropTypes.func,
  indexOfInvestigatorsDeatilsArray: PropTypes.number,
  InvestigationAssignedBlockValueArray: PropTypes.array,
  InvestigatorBlocksClickHandler: PropTypes.func,
  InvestigationAssignedBlockClickHandler: PropTypes.func,
};

export default InvestigatorBlocks;
